import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { TaskDetailReport } from './Pages';

export const TaskDetailReportRoutes  = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={TaskDetailReport} />
       
    </Fragment>
)